// Enum Kit
export enum eStatusKit {
    Estocado = 0,
    GerenteSetor = 1,
    Representante = 2,
    Revendedora = 3,
    PreConferido = 4,
    ConferidoErrado = 5,
    PreConferidoGerenteSetor = 6,
    PreConferidoGerenteRegional = 7,
    Finalizado = 8
}
export enum eStatusLiberacao {
    Normal = 0,
    Pendente = 1,
    Liberado = 2,
    NaoLiberado = 3
}
export enum eStatusProrrogacao {
    Nao = 0,
    Sim = 1
}

export enum eEstado {
    Normal = 0,
    Devendo = 1,
    NaoRetornou = 2
}

export enum eTipoKit {
    Novo = 0,
    Acerto = 1
}

export enum eBanho {
    Prata = 0,
    Ouro = 1,
    Rodio = 2
}

export enum eStatusTroca {
    Pendente = 0,
    Efetuada = 1,
    NaoEfetuada = 2,
    NaoVeioNaPasta = 3,
    Devedor = 4
}

export enum eStepTroca {
    EnviadoParaEmpresa = 0,
    RecebidoPelaEmpresa = 1,
    EnviadoParaGerenteSetor = 2,
    Finalizado = 3,
    NaoVeioNaPasta = 4,
    Devedor = 5
}

export enum eStatus {
    Inativo = 0,
    Ativo = 1,
    Pendente = 2,
    PreCadastro = 3,
    Analise = 4,
    Reprovado = 5
}

export enum eTipoOcorrencia {
    RG = 1,
    IA = 2,
    EC = 3,
    AL = 4,
    SF = 5,
    OJ = 6,
    TP = 7
}

export enum eStatusConsulta {
    Analise = 1,
    Aprovado = 2,
    Reprovado = 3
}
